import { createRouter, createWebHashHistory ,createWebHistory} from 'vue-router'
import Layout from '../views/layout/Layout.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/index.vue')
  },
  {
    path:'/blankJump',
    name: 'blankJump',
     meta: { requiresAuth: false },
    component: () => import(/* webpackChunkName: "blankJump" */ '../views/login/blankJump.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/management/user',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/management/user',
        name: 'userManagement',
        component: () => import(/* webpackChunkName: "userManagement" */ '../views/management/user/index.vue')
      },
      {
        path: '/management/node',
        name: 'nodeManagement',
        component: () => import(/* webpackChunkName: "nodeManagement" */ '../views/management/nodes/index.vue')
      },
      {
        path: '/management/user-node',
        name: 'userNode',
        component: () => import(/* webpackChunkName: "userNode" */ '../views/management/links/index.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/login')
      return
    }
  }
  next()
})

export default router
